import { getShadeBackground } from "./getShadeBackground";
import { WHITE_COLORS } from "../constants";
export var getShadeClearIconColor = function getShadeClearIconColor(shade, theme) {
  return WHITE_COLORS.includes(getShadeBackground(shade, theme)) ? theme.palette.grey[700] : theme.palette.common.white;
};
//# sourceMappingURL=getShadeClearIconColor.js.map